import { Injectable, HostListener } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { StorageService } from 'src/app/core/services/storage.service';

@Injectable({
  providedIn: 'root'
})

/** The SidebarService class manages the collapsed and mobile status of the sidebar and updates the
state of the application based on the current window size. */
export class SidebarService {

  private _collapsed: boolean = false;
  private _innerWidth: number = 0;
  private _isMobile: boolean = false;

  get collapsed(): boolean {return this._collapsed;}
  set collapsed(value: boolean) {this._collapsed = value;}

  get isMobile(): boolean {return this._isMobile;}
  set isMobile(value: boolean) {this._isMobile = value};

  constructor(private _storage: StorageService, private _breakpointObserver: BreakpointObserver,) {
    let rememberCollapse = this._storage.get('sidebarCollapsed');
    if(rememberCollapse) {
      this._collapsed = (rememberCollapse.toLowerCase() === 'true');
    }

    this._breakpointObserver.observe([
      "(max-width: 1180px)"
    ]).subscribe((result: BreakpointState) => {
      this.onResize(result.matches);
    });

  }

  /**
   * This function updates the state of the application based on the current window size and whether it
   * matches a specified breakpoint.
   * @param {boolean} [matchesBreakpoint=false] - matchesBreakpoint is a boolean parameter that is used
   * to determine if the current window width matches a specific breakpoint. If it is set to true or false, it
   * means that the window width matches the breakpoint or not and the _collapsed and _isMobile properties are
   * set accordingly.
   */
  onResize(matchesBreakpoint: boolean = false) {
    this._innerWidth = window.innerWidth;
    if(matchesBreakpoint) {
      this._collapsed = true;
      this._isMobile = true;
    } else {
      this._collapsed = false;
      this._isMobile = false;
    }
  }

  /** This functions toggles the sidebar collapsed status and also set it to the storage */
  toggleSidebar() {
    this._collapsed = !this._collapsed;
    this._storage.set('sidebarCollapsed', this._collapsed);
  }

  /** This function returns the sidebar collapsed status */
  getStatus() {
    return this._collapsed;
  }

}
